import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "Overview" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Espace client"),
  /*#__PURE__*/_createElementVNode("p", null, "Désolé cet espace est encore en construction")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}